export default {
  created() {
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    window.scrollTo(0, 0);
  },
};
